/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useLayoutEffect } from "react";
import Col from "../../UIcomponent/Column";
import "./BookingModal.scss";
import LocalContext from "../../Context/LocalContetxt";
import { PublicDic } from "../../Utility/PublicDic";
import BookingModalDic from "./BookingModalDic";
import AvailabiltySchedule from "../AvailabiltySchedule/AvailabiltySchedule";
import BookingReq from "../../Utility/Requester/BookingReq";
import BookingContext from "../../Context/BookingContext";
import AvaiScheduleMobile from "../AvaiScheduleMobile/AvaiScheduleMobile";
import LocalBooking from "../../Utility/Method/LocalBooking";
import { Loader } from "../../UIcomponent/Loader";
import DateTime from "../../Utility/Method/DateTime";
import moment from "moment-jalaali";
import AvatarDefault from "../../Assets/images/AvatarDefault.jpg";
import BookingModalLessons from "./BookingModalLessons";
import Modal from "../../UIcomponent/Modal";
import LoginRegister from "../../Component/LoginRegister/LoginRegister";
import { Redirect } from "react-router-dom";
import { PersianMonth } from "../../Utility/Method/DateTimeConstant";
import { TodayObj } from "../../Utility/TodayObj";
import LocalConfig from "../../Utility/Method/LocalConfig";
import Urls from "../../Utility/Urls";
import LocalAppConfig from "../../Utility/Method/LocalAppConfig";
import { StyledModal } from "../../UIcomponent/StyledModal";
import { getGuid } from "../../App";

const BookingingModal = (props) => {
  const lang = useContext(LocalContext).lang;
  const config = LocalConfig.Get();
  const isLoggedin = useContext(LocalContext).hasToken;
  const { intro, PublicUsername, setDisable, hadTrial } = props;
  let ID = props.ID || props.match.params.id;
  let localBook = LocalBooking.Get();
  const appConfig = LocalAppConfig.Get();
  const MinimumBookingIntervalInMinute =
    Number(appConfig.MinimumBookingIntervalInMinute / 60) || 0;
  let now = new Date(
    Date.now() + MinimumBookingIntervalInMinute * 60 * 60 * 1000
  );
  const [BookingState, setBookingState] = useState({
    currentStep: localBook && localBook.PriceID ? 1 : 0,
    step: {
      session: localBook && localBook.PriceID ? true : false,
      calendar: false,
      invoice: false,
    },
    TeacherLessons: null,
    TeacherLessonID: null,
    PackageID: null,
    SessionCount: localBook ? localBook.SessionCount : 0,
    sessionSelect: null,
    Slot: localBook ? localBook.Slot : null,
    teacherDateStatus: null,
    button: {
      loading: false,
      disable:
        localBook &&
        localBook.PriceID &&
        localBook.TimeSlots.length > 0 &&
        !config
          ? false
          : localBook &&
            localBook.PriceID &&
            localBook.TimeSlots.length > 0 &&
            config &&
            config.role !== "Teacher"
          ? false
          : true,
    },
  });
  const [isRedirect, setIsRedirect] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [hasAvailabe, setHasAvailable] = useState(true);
  const [avaiSlot, setAvailSlot] = useState([]);
  let width = window.innerWidth;
  let BookingCtxt = useContext(BookingContext);

  let Step = [];
  for (let i = 0; i < props.stepCount; i++) {
    Step.push({});
  }
  const WeekDateTimeObj = (firstDay, mode) => {
    if (mode === "next") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else if (mode === "previous") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else {
      return null;
    }
  };

  const GetAvailabilty = (firstDay, mode, callBack) => {
    let params = {
      timeZone: DateTime.timeZone(),
      dateTimeFrom: WeekDateTimeObj(firstDay, mode).dateTimeFrom,
      dateTimeTo: WeekDateTimeObj(firstDay, mode).dateTimeTo,
    };
    if (callBack) {
      callBack();
    }
    setLoading(true);
    BookingReq.getAvailability(ID, params)
      .then((res) => {
        let newResult = [];
        if (res.data !== null) {
          newResult = res.data.map((each) => {
            return {
              status: 1,
              date_time_from: each.from,
              date_time_to: each.to,
            };
          });
        } else {
          setHasAvailable(false);
        }
        localBook && newResult.push(...localBook.TimeSlots);
        setAvailSlot([...newResult]);
        setLoading(false);
      })
      .catch((err) => {});
  };

  useLayoutEffect(() => {
    moment.locale("en");
  }, []);

  useEffect(() => {
    BookingReq.GetLesson(ID)
      .then((res) => {
        let RES = res.data.map((lesson) => {
          return {
            ...lesson,
            Packages: lesson.Packages.map((pack, index) => {
              if (window.ga) {
                window.ga("ec:addProduct", {
                  id: pack.ID,
                  name: lesson.Title,
                  brand: `${intro.FirstName} ${intro.LastName}`,
                  category: lesson.IsTrial ? "Trial" : "Normal",
                  price: pack.SingleSessionPrice,
                  quantity: pack.PackageSessionCount,
                  list: "Teacher list",
                  position: index,
                });
              }
              return {
                ...pack,
                isSelected:
                  localBook && pack.ID === localBook.PriceID ? true : false,
              };
            }),
          };
        });
        let hasPackageActive =
          RES.filter((each) => each.Packages.length > 0).length === 0
            ? false
            : true;
        setBookingState({
          ...BookingState,
          TeacherLessons: RES,
        });
        setDisable(!hasPackageActive);
        setLoading(false);
      })
      .catch((err) => {});
    if (BookingState.step.session && props.visible) {
      GetAvailabilty(TodayObj(MinimumBookingIntervalInMinute), "next");
    }
  }, [props.visible]);

  const cancelModal = () => {
    if (window.ga) {
      window.ga("ec:setAction", "remove", {
        id: getGuid(),
        step: 3,
      });
    }

    props.onCancel();
    LocalBooking.Remove();
    setBookingState({
      ...BookingState,
      button: {
        ...BookingState.button,
        disable: true,
      },
      step: {
        session: false,
        calendar: false,
        invoice: false,
      },
    });
  };
  const sessionSelect = (
    LessonTypeID,
    TeacherID,
    PricePackageID,
    SingleSessionPrice
  ) => {
    let newSessionList = [...BookingState.TeacherLessons];
    newSessionList.map((each, I) =>
      each.Packages.forEach((pack, i) =>
        each.ID === LessonTypeID && pack.ID === PricePackageID
          ? (pack.isSelected = true)
          : (pack.isSelected = false)
      )
    );
    let Slot =
      newSessionList
        .filter(
          (each) => each.Packages.filter((pack) => pack.isSelected === true)[0]
        )[0]
        .Packages.filter((pack) => pack.isSelected === true)[0]
        .SessionLengthInMinute / 30;
    let SessionCount = BookingState.TeacherLessons.filter(
      (each) => each.Packages.filter((pack) => pack.isSelected === true)[0]
    )[0].Packages.filter((pack) => pack.isSelected === true)[0]
      .PackageSessionCount;
    setBookingState({
      ...BookingState,
      sessionList: newSessionList,
      sessionSelect: newSessionList
        .filter(
          (each) => each.Packages.filter((pack) => pack.isSelected === true)[0]
        )[0]
        .Packages.filter((pack) => pack.isSelected === true)[0]
        .PackageSessionCount,
      Slot,
      SessionCount,
      button: {
        ...BookingState.button,
        disable: false,
      },
    });
    let Booking;
    let newLocalBook;
    let newDateStatus = [...BookingCtxt.DateStatus];
    Booking = {
      ID: Number(ID),
      TeacherInfo: {
        Avatar: intro.UserAvatar,
        FirstName: intro.FirstName,
        LastName: intro.LastName,
      },
      PublicUsername,

      Slot,
      SessionCount,
      TeacherID,
      LessonID: LessonTypeID,
      isTrial:
        BookingState.TeacherLessons.filter(
          (lesson) => lesson.ID === LessonTypeID && lesson.IsTrial
        ).length > 0,
      PriceID: PricePackageID,
      SingleSessionPrice,
      PayableAmount: SingleSessionPrice * SessionCount,
      DateTime: Date.now(),
      TimeSlots: [],
    };

    if (
      localBook &&
      localBook.ID !== Number(ID) &&
      localBook.PricePackageID !== PricePackageID
    ) {
      newLocalBook = LocalBooking.Get();
      newLocalBook.SessionCount = SessionCount;
      newLocalBook.Slot = Slot;
      newLocalBook.LessonID = LessonTypeID;
      newLocalBook.PublicUsername = PublicUsername;
      newLocalBook.PriceID = PricePackageID;
      newLocalBook.SingleSessionPrice = SingleSessionPrice;
      newLocalBook.TimeSlots = [];
      newLocalBook.IsTrial =
        BookingState.TeacherLessons.filter(
          (lesson) => lesson.ID === LessonTypeID && lesson.IsTrial
        ).length > 0;
      LocalBooking.Set(newLocalBook);
      newDateStatus = newDateStatus.filter((each) => !each.id);
      BookingCtxt.setDateStatus(newDateStatus);
    } else {
      LocalBooking.Set(Booking);
    }
  };
  const nextHandler = () => {
    if (BookingState.step.session === false) {
      const Func = () => {
        setBookingState({
          ...BookingState,
          currentStep: 1,
          step: {
            ...BookingState.step,
            session: true,
          },
          button: {
            ...BookingState.button,
            disable: true,
          },
        });
      };
      GetAvailabilty(TodayObj(MinimumBookingIntervalInMinute), "next", Func);
    } else if (
      BookingState.step.session === true &&
      BookingState.step.calendar === false
    ) {
      if (isLoggedin) {
        if (window.ga)
          window.ga("ec:setAction", "add", {
            id: getGuid(),
            step: 3,
          });
        if (config.role === "Student") {
          if (localBook.SingleSessionPrice === 0) {
            setIsRedirect(true);
          } else {
            setIsRedirect(true);
          }
        }
      } else {
        setShowLogin(true);
      }
    } else {
      return null;
    }
  };
  const BackHandler = () => {
    if (
      BookingState.step.session === true &&
      BookingState.step.calendar === false
    ) {
      setBookingState({
        ...BookingState,
        currentStep: 0,
        step: {
          ...BookingState.step,
          session: false,
        },
        button: {
          ...BookingState.button,
          disable: false,
        },
      });
    }
  };
  const onSelect = () => {
    if (
      (BookingState.SessionCount > 0 && config && config.role !== "Teacher") ||
      (BookingState.SessionCount > 0 && !config)
    ) {
      setBookingState({
        ...BookingState,
        button: {
          ...BookingState.button,
          disable: false,
        },
      });
    }
  };
  const onDeselect = (leftChoise) => {
    if (BookingState.SessionCount - 1 == leftChoise) {
      setBookingState({
        ...BookingState,
        button: {
          ...BookingState.button,
          disable: true,
        },
      });
    }
  };
  const onNextWeek = (firstDay) => {
    GetAvailabilty(firstDay, "next");
  };
  const onPreviousWeek = (firstDay) => {
    GetAvailabilty(firstDay, "previous");
  };
  const cancelLoginModal = () => {
    setShowLogin(false);
  };
  const onRemove = (leftChoise) => {
    if (BookingState.SessionCount - 1 == leftChoise) {
      setBookingState({
        ...BookingState,
        button: {
          ...BookingState.button,
          disable: true,
        },
      });
    }
  };
  const FooterRightSideComponent = () => {
    return (
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={0}
        className="c__Booking__Modal__Footer__Info"
      >
        <Col className="o__Booking__Modal__Footer__Info__TeacherAvatar">
          <Col
            style={{
              backgroundImage: `Url(${
                intro && intro.UserAvatar != ""
                  ? Urls.avatar() + intro.UserAvatar
                  : AvatarDefault
              })`,
            }}
          ></Col>
        </Col>
        <Col className="o__Booking__Modal__Footer__Info">
          {BookingState.TeacherLessons &&
            BookingState.TeacherLessons.map((each) => {
              return each.Packages.filter(
                (pack) => pack.isSelected && pack.isSelected === true
              ).map((each) => {
                return (
                  <>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                      {each.PackageSessionCount === 0
                        ? BookingModalDic.trial[`${lang}`]
                        : each.PackageSessionCount === 1
                        ? each.PackageSessionCount +
                          " " +
                          PublicDic.session[`${lang}`]
                        : PublicDic.package[`${lang}`] +
                          " - " +
                          each.PackageSessionCount +
                          " " +
                          PublicDic.session[`${lang}`]}
                    </Col>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                      {each.SessionLengthInMinute +
                        " " +
                        PublicDic.minute[`${lang}`]}
                    </Col>
                  </>
                );
              });
            })}
        </Col>
        <Col className="o__Booking__Modal__Footer__Info__Session">
          {BookingState.SessionCount == 1 &&
            localBook &&
            localBook.TimeSlots.length > 0 &&
            localBook.TimeSlots.map((each) => {
              return (
                each.id && (
                  <>
                    <Col>
                      {DateTime.getDayFullStr(
                        moment(each.date_time_from).format("ddd")
                      )[`${lang}`] +
                        " , " +
                        moment(new Date(each.date_time_from)).format("jDD") +
                        " " +
                        PersianMonth[
                          Number(
                            moment(new Date(each.date_time_from)).format("jMM")
                          ) - 1
                        ]}
                    </Col>
                    <Col>
                      {moment(each.date_time_from).format("HH") +
                        ":" +
                        moment(each.date_time_from).format("mm") +
                        " تا " +
                        moment(each.date_time_to).format("HH") +
                        ":" +
                        moment(each.date_time_to).format("mm")}
                    </Col>
                    {/* {each.date_time_from} */}
                  </>
                )
              );
            })}
        </Col>
      </Col>
    );
  };
  const FooterLeftSideComponent = () => {
    return (
      BookingState.TeacherLessons &&
      BookingState.TeacherLessons.map((each) => {
        return each.Packages.filter((pack) => pack.isSelected === true).map(
          (session) => {
            return (
              <Col
                xl={8}
                lg={8}
                md={12}
                sm={6}
                xs={0}
                className="o__Booking__Modal__Footer__Action__Price"
              >
                {!each.IsTrial && session.SingleSessionPrice !== 0 && (
                  <Col>
                    {(
                      (session.PackageSessionCount *
                        session.SingleSessionPrice) /
                      10
                    ).toLocaleString(lang) +
                      " " +
                      PublicDic.Toman}
                  </Col>
                )}
                {each.IsTrial === true && !hadTrial && (
                  <Col>{PublicDic.free[`${lang}`]}</Col>
                )}
              </Col>
            );
          }
        );
      })
    );
  };
  return isRedirect ? (
    <Redirect {...props} to={"/invoice"} />
  ) : (
    <>
      <StyledModal
        visible={props.visible}
        hasHeaderAction={BookingState.step.session}
        headerActionHandler={BackHandler}
        modalTitle={
          BookingState.step.session === false
            ? "نوع کلاس"
            : "انتخاب زمان بندی کلاس"
        }
        onClose={cancelModal}
        FooterActionDisable={BookingState.button.disable}
        confirmHandler={nextHandler}
        FooterRightSideComponent={FooterRightSideComponent}
        FooterLeftSideComponent={FooterLeftSideComponent}
        totalStep={3}
        currentStep={BookingState.currentStep}
        FooterActionText={"بعدی"}
      >
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__Booking__Modal__Content"
        >
          {BookingState.step.session === false && loading && (
            <Loader width={150} height={150} />
          )}
          {BookingState.step.session === false &&
            BookingState.TeacherLessons && (
              <BookingModalLessons
                lang={lang}
                sessionSelect={sessionSelect}
                hadTrial={hadTrial}
                lessons={BookingState.TeacherLessons}
              />
            )}
          {BookingState.Slot &&
            BookingState.step.session === true &&
            BookingState.step.calendar === false && (
              <Col
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="c__Booking__Modal__Calendar"
              >
                {width > 768 && localBook && (
                  <AvailabiltySchedule
                    initialMoment={now}
                    duration={0.5}
                    lang={lang}
                    row={8}
                    size={30}
                    Data={avaiSlot}
                    hasData={hasAvailabe}
                    onSelect={onSelect}
                    onDeselect={onDeselect}
                    onRemove={onRemove}
                    SessionCount={BookingState.SessionCount}
                    Slot={localBook.Slot}
                    onNextWeek={onNextWeek}
                    onPreviousWeek={onPreviousWeek}
                    ID={props.ID}
                    loading={loading}
                    Loader={Loader}
                    localSave={true}
                    role={config ? config.role : null}
                    {...props}
                  />
                )}
                {width < 768 && localBook && (
                  <AvaiScheduleMobile
                    initialMoment={now}
                    duration={0.5}
                    lang={lang}
                    row={8}
                    size={30}
                    Data={avaiSlot}
                    role={config && config.role}
                    onSelect={onSelect}
                    onDeselect={onDeselect}
                    SessionCount={BookingState.SessionCount}
                    Slot={localBook.Slot}
                    onRemove={onRemove}
                    onNextWeek={onNextWeek}
                    onPreviousWeek={onPreviousWeek}
                    setState={setBookingState}
                    loading={loading}
                    Loader={Loader}
                    localSave={true}
                    ID={props.ID}
                  />
                )}
              </Col>
            )}
        </Col>
      </StyledModal>
      <Modal visible={showLogin} onCancel={cancelLoginModal}>
        <LoginRegister />
      </Modal>
    </>
  );
};

export default BookingingModal;
